import React from "react";
import ElementProducts from "./components/ElementProducts";
import {createRoot} from "react-dom/client";

export default () => {

    const doms = document.querySelectorAll('[data-product-element]');
    for (const dom of doms) {
        const eRoot = createRoot(dom);
        eRoot.render(<ElementProducts
            link={dom.getAttribute('data-product-element')}/>);
    }
}
